/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { space, color, display } from '@style'

/**
 * Facebook Icon
 * @param {https://github.com/adamwathan/entypo-optimized} param0
 */
function Icon({ size, ...props }) {
  return (
    <svg
      viewBox="0 0 20 20"
      width={size}
      height={size}
      {...props}
      fill="currentcolor"
    >
      <path d="M8.294 16.998c-.435 0-.847-.203-1.111-.553L3.61 11.724a1.392 1.392 0 01.27-1.951 1.392 1.392 0 011.953.27l2.351 3.104 5.911-9.492a1.396 1.396 0 011.921-.445c.653.406.854 1.266.446 1.92L9.478 16.34a1.39 1.39 0 01-1.12.656c-.022.002-.042.002-.064.002z" />
    </svg>
  )
}

Icon.propTypes = {
  size: PropTypes.oneOf([12, 24, 48]).isRequired,
}

const Check = styled(Icon)([], space, color, display)

Check.displayName = 'Check'

Check.defaultProps = {
  size: 24,
}

export default Check
